export default __webpack_public_path__ + "static/media/escalera5.c0d22235.png";